import React, { useRef, useState, useMemo } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Fader from '../Loaders/Fader';

import useOutsideClick from '../../../hooks/useOutsideClick';

import ChevronIcon from '../../../assets/images/icons/chevron.svg';
import './ConstituentSelect.scss';

const ConstituentSelect = ({ label, constituents, loading, setSelectedConstituent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  const selectRef = useRef(null);
  const selectInput = useRef(null);

  const filtered = useMemo(() => {
    if (!search) return constituents;

    const query = search.toLowerCase();

    return constituents
      .filter(
        (c) =>
          c.name?.toLowerCase().includes(query) ||
          c.email?.toLowerCase().includes(query) ||
          c.phone?.includes(query) ||
          c.address?.toLowerCase().includes(query) ||
          c.postal_code?.toLowerCase().includes(query),
      )
      .slice(0, 20);
  }, [search, constituents]);

  const handleSelect = (constituent) => {
    setSelectedConstituent(constituent);
    setIsOpen(false);
    setSearch('');
  };

  useOutsideClick(selectRef, selectInput, isOpen, () => setIsOpen(false));

  return (
    <div className={`constituent-select custom-select ${isOpen ? 'opened' : ''}`} ref={selectRef}>
      <span className="input__label">{label}</span>
      <div ref={selectInput} className="selected-option" onClick={() => setIsOpen(!isOpen)}>
        <span className="selected-option__name">Select constituent</span>
        <div className="arrow-wrapper">
          <img src={ChevronIcon} className={`arrow ${isOpen ? 'rotated' : ''}`} />
        </div>
      </div>
      {isOpen && (
        <div className={`options-wrapper n${filtered.length}`}>
          <input
            className="constituent-search"
            placeholder="Search name, email, phone, postal code, address..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {loading ? (
            <Fader />
          ) : filtered.length === 0 ? (
            <span className="no-data">No constituents found</span>
          ) : (
            <PerfectScrollbar
              options={{
                wheelPropagation: false,
                autoHide: false,
              }}
            >
              <ul className="options-list">
                {filtered.map((c) => (
                  <li key={c.id} onClick={() => handleSelect(c)}>
                    <b>{c.name ? c.name : '(No name)'}</b> — {c.postal_code}
                    {(c.email || c.phone) && ` — ${c.email || c.phone}`}
                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
          )}
        </div>
      )}
    </div>
  );
};

export default ConstituentSelect;
